module.exports = __webpack_public_path__ + "static/ey-5-430c31abc5b572783b5f84e4da5915ad.png";